<template>
  <div class="flex flex-col">
    <div class="flex items-center pb-3">
      <svg-icon
        name="manufacturer"
        class="me-3 icon-7xl flex-initial contact-us_manufacturer-logo"
      />
      <p class="whitespace-pre-line flex-shrink-0 contact-us_manufacturer">
        {{ $t("Legal.address") }}
      </p>
      <svg-icon name="ce_logo" class="ms-10 icon-7xl contact-us_ce-logo" />
    </div>
    <div class="flex items-center pb-3">
      <svg-icon
        name="european-representative"
        class="me-3 icon-7xl flex-initial contact-us_european-representative-logo"
      />
      <p
        class="whitespace-pre-line flex-shrink-0 contact-us_european-representative"
      >
        {{ $t("Legal.europeanRepresentativeAddress") }}
      </p>
    </div>
    <div class="flex pt-4">
      <div
        class="inline-block px-2 py-1 border border-blue-800 rounded text-blue-800"
      >
        <span class="font-bold text-lg">UDI</span>
        <span class="contact-us_udi">
          (01)03760272650095(10) {{ productVersion }}
        </span>
      </div>
    </div>
    <div class="flex pt-4">
      <p class="text-sm">{{ $t("Legal.trademarkNotice") }}</p>
    </div>
    <div class="flex pt-4">
      <p class="text-sm">{{ $t("Legal.copyrightNotice", { currentYear }) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productVersion: {
      type: String,
      default: "",
    },
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
